<template>
  <div>
    <loading name="lp" :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <base-header class="pb-6">
      <div class="row align-items-center py-0"></div>
    </base-header>
    <div class="container-fluid mt--6">
      <div>
        <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
          <template slot="header">
            <h3 class="mb-0">Schedule</h3>
            <p class="text-sm mb-0">Agenda</p>
          </template>
          <div class="row card-body">
            <div class="col-lg-2">
              <base-input label="Start date">
                <flat-picker
                  class="form-control datepicker"
                  :config="{ allowInput: true, }"
                  v-model="filter.start"
                ></flat-picker>
              </base-input>
            </div>
            <div class="col-lg-2">
              <base-input label="End date">
                <flat-picker
                  :config="{ allowInput: true, minDate: filter.start}"
                  class="form-control datepicker"
                  v-model="filter.end"
                ></flat-picker>
              </base-input>
            </div>
            <div class="col-lg-5">
              <base-input label="Criteria">
                <table>
                  <tr>
                    <td>
                      <el-select
                        class="select-primary pagination-select"
                        v-model="filter.searchtype"
                        placeholder="Select"
                        @change="filter.id = ''"
                      >
                        <el-option class="select-primary" :key="1" label="Teacher" :value="1"></el-option>
                        <el-option class="select-primary" :key="2" label="Class" :value="2"></el-option>
                        <el-option class="select-primary" :key="3" label="Course" :value="3"></el-option>
                      </el-select>
                    </td>
                    <td>
                      <el-select
                        v-if="filter.searchtype === 1"
                        class="select-primary pagination-select"
                        v-model="filter.id"
                        placeholder="Teacher"
                      >
                        <el-option
                          class="select-primary"
                          v-for="item in teachers"
                          :key="item.id"
                          :label="item.fullname"
                          :value="item.id"
                        ></el-option>
                      </el-select>

                      <el-select
                        v-if="filter.searchtype === 2"
                        class="select-primary pagination-select"
                        v-model="filter.id"
                        placeholder="Class"
                      >
                        <el-option
                          class="select-primary"
                          v-for="item in classes"
                          :key="item.id"
                          :label="item.code"
                          :value="item.id"
                        ></el-option>
                      </el-select>

                      <el-select
                        v-if="filter.searchtype === 3"
                        class="select-primary pagination-select"
                        v-model="filter.id"
                        placeholder="Course"
                      >
                        <el-option
                          class="select-primary"
                          v-for="item in courses"
                          :key="item.id"
                          :label="item.title"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </td>
                  </tr>
                </table>
              </base-input>
            </div>
            <div class="col-lg-1">
              <base-button type="primary" @click.prevent="onGo">Go</base-button>
            </div>

            <div class="col-lg-12">
              <schedule-item
                v-for="item in gsched"
                :key="item.date"
                :date="item.date"
                :items="item.items"
              ></schedule-item>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import swal from "sweetalert2";
import { Table, TableColumn, Select, Option } from "element-ui";
import { BasePagination } from "@/components";
import { nophoto } from "../../../services/user";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { GetTeachers } from "../../../services/user";
import { GetActiveCourses } from "../../../services/courses";
import { GetClasses, GetSchedule } from "../../../services/classes";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import ScheduleItem from "./ScheduleItem";
export default {
  components: {
    BasePagination,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Loading,
    flatPicker,
    ScheduleItem,
  },
  data() {
    return {
      tableData: [],
      teachers: [],
      courses: [],
      classes: [],
      sched: [],
      gsched: [],
      groupsched: [],
      filter: {
        start: new Date(),
        end: new Date(),
        searchtype: 1,
        id: "",
      },
      endDate: null,
      isLoading: false,
    };
  },
  methods: {
    onGo() {
      this.isLoading = true;
      GetSchedule(this.filter).then((response) => {
        this.isLoading = false;
        if (response.data.result) {
          this.sched = response.data.result;
          this.gsched = this.groupping();
        } else {
        this.sched = [];
        this.gsched = [];
        if (response.data)
          this.notifyVue(
            "danger",
            response.data ? response.data : "No data found"
          ); }
      });
    },
    groupping() {
      let list = [];
      for (let i = 0; i < this.sched.length; i++) {
        let dt = { date: this.sched[i].lessondate.substring(0, 10), items: [] };
        let pos = list
          .map(function (e) {
            return e.date;
          })
          .indexOf(dt.date);
        if (pos === -1) {
          list.push(dt);
        }
      }

      for (let i = 0; i < list.length; i++) {
        list[i].items = this.sched.filter(
          (c) => c.lessondate.substring(0, 10) === list[i].date
        );
      }
      return list;
    },
  },
  mounted() {
    this.filter.end = new Date(this.filter.end).setDate(
      new Date(this.filter.end).getDate() + 14
    );
    this.filter.start = new Date();
    GetTeachers().then((response) => {
      if (response.data !== null) {
        this.teachers = response.data.result;
      }
    });

    GetActiveCourses().then((response) => {
      if (response.data !== null) {
        this.courses = response.data.result;
      }
    });

    GetClasses(1).then((response) => {
      if (response.data !== null) {
        this.classes = response.data.result;

        this.onGo();
      }
    });

  },
};
</script>

<style lang="scss" scoped>
</style>